import { DatePipe } from "@angular/common";
import { Tag } from "@models/tag";
import { IEntity } from "../interfaces/entity";

export class RfidCardDto implements IEntity {
  id: number;
  idTag: string;

  userId: string;
  userFirstName: string;
  userLastName: string;

  chargingStationId?: string;

  customerId: number;

  lastAuthorizationDate: DatePipe;
  expiryDate: DatePipe;

  lastUsedChargingStationId: string;
  lastUsedChargingStationName: string;

  tags: Tag[];

  note: string;
  tagsString: string;

  isCreatedBySystem: boolean;
  isOwnerChanged: boolean;

  entityName = "RfidCardDto";

  getPrimaryKey() {
    return this.id;
  }

  updateValues(formValue: Partial<RfidCardDto>) {
    Object.assign(this, formValue);
  }

}
